/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */

export const isTokenPresent = () => {
  const token = localStorage.getItem("sessionToken");
  const expirationTime = localStorage.getItem("sessionTokenExpiration");

  if (token && expirationTime) {
    const currentTime = new Date().getTime();
    if (parseInt(expirationTime) <= currentTime) {
      // Si la date d'expiration est dépassée, supprimer le token et rediriger
      localStorage.removeItem("sessionToken");
      localStorage.removeItem("sessionTokenExpiration");
      localStorage.removeItem("specialTokenDev");
      localStorage.removeItem("specialTokenAdmin");
      localStorage.removeItem("specialTokenSuperAdmin");
      localStorage.removeItem("NameUser");
      window.location.href = "/";
      return false;
    }
    return true;
  }
  return false;
};